<template>
  <div class="attribution">
    <div class="attribution_titleArea">
      <h3 class="title">转化归因</h3>
    </div>
    <div class="attribution_main">
      <div class="main_item">
        <div class="item_title">
          <span class="text">归因方式</span>
        </div>
        <div class="item_main">
          <el-radio
            v-model="attribution"
            label="1"
            @change="attrwe"
          >全网归因</el-radio>
          <el-radio
            v-if="type ==='edit2' || type ==='edit3'"
            v-model="attribution"
            label="2"
            @change="attrwe"
          >精准匹配归因</el-radio>
        </div>
      </div>
      <div v-if="attribution === '2'" class="main_item" style="margin-top:20px">
        <div class="item_title">
          <span class="text">数据源</span>
        </div>
        <div>{{ name }}</div>
        <el-button size="small" @click="setDataSource">选择数据源</el-button>
      </div>
    </div>
    <el-dialog width="30%" title="选择数据源" :visible.sync="dialogTableVisible" :close-on-click-modal="false" :show-close="false" :close-on-press-escape="false">
      <el-table
        v-loading="loading"
        :data="publicDirectionList"
        style="width: 100%"
      >
        <el-table-column
          :key="refreshKey"
          label="选项"
          width="100"
        >
          <template scope="scope">
            <input v-model="scope.row.checkboxFlag" type="checkbox" @click="handleChangeSelect(scope.$index, scope.row)">
            {{ scope.row.$index }}
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          label="公共定向包名称"
          width="180"
        />
        <el-table-column
          prop="user_action_set_id"
          label="定向包ID"
          width="140"
        />
      </el-table>
      <el-button type="primary" style="margin-top:30px" @click="bnew">确定</el-button>
    </el-dialog>
  </div>
</template>

<script>
import { getDataSource } from '@/api/legacyPlan.js'
export default {
  props: {
    tracking_sourceid: {},
    zhuanhuaname: {}
  },
  data() {
    return {
      attribution: '1',
      dialogTableVisible: false,
      publicDirectionList: [],
      refreshKey: 0,
      loading: false,
      ids: '',
      name: '',

      type: ''
    }
  },
  created() {
    // 获取可以显示归因吗
    console.log('sessionStorage.getItem', sessionStorage.getItem('newtype'))
    this.type = sessionStorage.getItem('newtype')

    this.name = this.zhuanhuaname
    console.log('this.tracking_sourceid', this.tracking_sourceid.length)
    // 如果tracking_sourceid为空 就是全网归因 否则为精准匹配归因
    if (this.tracking_sourceid.length === 0) {
      this.attribution = '1'
      this.name = ''
      // 要展示名字的回传
      this.$emit('dataname', '')
    } else {
      this.attribution = '2'
    }
  },
  methods: {
    // 点击弹窗 获取数据源的数据
    setDataSource() {
      this.dialogTableVisible = true
      this.loading = true
      getDataSource().then(res => {
        console.log('res', res.data)
        this.publicDirectionList = res.data
        this.publicDirectionList.forEach(item => {
          item.checkboxFlag = false
          if (item.user_action_set_id === this.tracking_sourceid[0]) {
            item.checkboxFlag = true
          }
        })
        this.loading = false
      })
    },
    bnew() {
      this.$emit('dataidsr', Number(this.ids))
      this.dialogTableVisible = false
      console.log('ids', this.ids)
    },
    // checkbox单选效果
    handleChangeSelect(index) {
      if (!this.publicDirectionList[index].checkboxFlag) {
        this.ids = this.publicDirectionList[index].user_action_set_id
        this.name = this.publicDirectionList[index].name
        // 要展示名字的回传
        this.$emit('dataname', this.publicDirectionList[index].name)
      } else {
        this.ids = ''
        this.name = ''
        // 要展示名字的回传
        this.$emit('dataname', '')
      }
      this.publicDirectionList.forEach(item => {
        item.checkboxFlag = false
      })
      this.publicDirectionList[index].checkboxFlag = true
      this.refreshKey = Math.random()
    },
    attrwe() {
      console.log(this.attribution)
      if (this.attribution === '1') {
        console.log('全网归因')
        this.$emit('dataidsrempty')
      } else {
        if (this.ids === '') {
          console.log('5555')
          this.$emit('dataidsrempty')
        } else {
          console.log('6666')
          this.$emit('dataidsr', Number(this.ids))
        }
        console.log('精准匹配归因')
      }
    }
  }
}
</script>

<style scoped lang="less">
.attribution {
  width: 100%;
  padding: 0 0 32px;
  background: #fff;
  border-radius: 6px;
  box-shadow: 0 3px 6px 0 rgb(0 0 0 / 4%), 0 0 0 1px hsl(0deg 0% 87% / 50%);
  margin-bottom: 12px;
  .attribution_titleArea {
    padding: 18px 24px;
    border-bottom: 1px solid #f2f2f2;
    .title {
      margin-bottom: 2px;
      font-size: 14px;
      line-height: 24px;
      color: #1f1f1f;
      font-weight: 600;
    }
  }
  .attribution_main {
    padding: 0px 24px;
    .main_item {
      display: flex;
      margin: 10px 0px;
      align-items: center;
      .item_title {
        width: 110px;
        .text {
        }
      }
      .item_main {
        display: flex;
      }
    }
  }
}
</style>
